<template>
    <b-container>
        <b-row>
            <b-col>
                <app-sub-title text="Clientes que más PQR's reportan" />
            </b-col>
        </b-row>
        <b-row>
            <b-col>
                <app-data-table
                    :fields="fields"
                    :items="tableData"
                >
                    <template slot="percentaje" slot-scope="props">
                        {{props.item.percentaje | decimal(2)}}
                    </template>
                    <template slot="acum" slot-scope="props">
                        {{props.item.acum | decimal(2)}}
                    </template>
                </app-data-table>
            </b-col>
        </b-row>
    </b-container>
</template>
<script>
import reportingRepository from '../../../../../repositories/reporting.repository';

export default {
    name: 'pqr_pareto_clients',
    data: () => ({
        rawData: [],
        fields: [
            {
                key: 'name',
                label: 'Cliente'
            },
            {
                key: 'cant',
                label: 'PQRs'
            },
            {
                key: 'percentaje',
                label: 'Porcentaje'
            },
            {
                key: 'acum',
                label: 'Acumulado'
            },
        ]
    }),
    computed: {
        tableData() {
            return this.rawData.map(item => ({...item, classes: item.acum <= 80? 'item-important': 'item-trivial'}));
        }
    },
    methods: {
        async loadPqrsParetoByClient() {
            try {
                const rr = {...reportingRepository};
                const {data} = await rr.getPqrParetoClients();
                this.rawData = data;
            } catch(err) {
                toastr.error(`Ocurrió un error al cargar el Pareto de Clientes [${err.message}]`);
            }
        }
    },
    created() {
        this.loadPqrsParetoByClient();
    }
}
</script>